export default class Accordion {
    constructor(element) {
        this.element = element;
        this.triggers = element.querySelectorAll('.accordion__trigger');
        this.contents = element.querySelectorAll('.accordion__content');
        this.activeIndex = null;
        if (this.triggers === null || this.triggers.length === 0) {
            throw "The accordion needs to contain at least one item.";
        }
        if (!element.classList.contains('accordion--hide')) {
            this.activeIndex = 0;
        }
        for (let i = 0; i < this.triggers.length; i++) {
            this.triggers[i].addEventListener('click', () => {
                if (this.activeIndex === i) {
                    this.setActiveIndex(null);
                    return;
                }
                this.setActiveIndex(i);
            });
        }
        this.draw();
    }
    draw() {
        this.unfocusAll();
        if (this.activeIndex !== null) {
            this.activateContent(this.contents[this.activeIndex]);
            this.activateTrigger(this.triggers[this.activeIndex]);
        }
    }
    activateTrigger(element) {
        if (!element.classList.contains('active')) {
            element.classList.add('active');
        }
        element.setAttribute('aria-expanded', 'true');
    }
    activateContent(element) {
        if (!element.classList.contains('active')) {
            element.classList.add('active');
        }
        element.hidden = false;
    }
    unfocusAll() {
        this.contents.forEach(content => {
            content.classList.remove('active');
            content.hidden = true;
        });
        this.triggers.forEach(trigger => {
            trigger.classList.remove('active');
            trigger.setAttribute('aria-expanded', 'false');
        });
    }
    setActiveIndex(index) {
        this.activeIndex = index;
        this.draw();
    }
}
